import { LayoutContainer, LeftColumnContainer, RightColumnContainer } from 'components/shared';

import { Link } from '@bcm-dev/bcms-vite';
import React from 'react';

import './styles.css';

/**
 * @function MobileStatementTable
 * @returns {React.Component}
 * @exported true
 * @description The mobile adaptive view for the StatementsTable.
 * @example
 * <MobileStatementTable>
 *  <MobileStatementsTableRow />
 * </MobileStatementTable>
 */

export default function MobileStatementTable(props) {
  return (
    <div className="mobile-statements-table flex-container flex-vertical flex-width">
        { props.children }
    </div>
  )
}

/**
 * @function MobileStatementsTableRow
 * @returns {React.Component}
 * @exported false
 * @description The row for each statement for the MobileStatementTable.
 * @example
 * <MobileStatementTable>
 *  <MobileStatementsTableRow link={<Link to="/">Link Text</Link>} accountNickname="Checking Account" accountNumber="x1234" documentName="Doc-Name" documentType="pdf" />
 * </MobileStatementTable>
 */

export function MobileStatementsTableRow(props) {
  const link = props.link ?? (<Link to="/" className="top-row-text">[Link]</Link>);
  const documentName = props.documentName ?? "[Document Name]";
  const documentType = props.documentType ?? "[Document Type]";
  const accountNickname = props.accountNickname ?? "[Account Nickname]";
  const accountNumber = props.accountNumber ?? "[x1234]";
  const id = props.id ?? "";

  return (
    <div className="mobile-statements-table-row flex-container flex-horizontal">
      <LayoutContainer>
        <LeftColumnContainer>
          <b>{link}</b>
          <p className="sub-text">{documentType}</p>
        </LeftColumnContainer>
        <RightColumnContainer>
          <p className="text-right top-row-text"><b>{accountNickname}</b></p>
          <p className="sub-text text-right">{documentName}</p>
        </RightColumnContainer>
      </LayoutContainer>
    </div>
  )
}